@if (isOutage) {
  <app-standard-page class="outage">
    <app-standard-page-content>
      <div class="p-3">
        <!-- <h1>There seems to be an outage</h1> -->
        <h1>We can't connect at the moment</h1>
        <p>FinQuery Fixed Assets is currently undergoing maintenance.</p>
        <p>
          Please
          <a
            data-dd-action-name="outage.try-again-button"
            class="link"
            (click)="refresh()"
            >try again</a
          >
          soon.
        </p>
      </div>
    </app-standard-page-content>
  </app-standard-page>
}
